import * as yup from 'yup';

import { ParticipantFieldType } from '__generated__/graphql';

const testMinEnabledChoices = (schema: yup.ArraySchema<any>, min: number) => (
  schema.test({
    name: 'min_enabled_choices',
    message: '',
    params: { min },
    test: (choices) => (
      (choices ?? []).filter((c) => c.enabled).length >= min
    ),
  })
);

const typeBasedLengthValidation = (type: string, schema: yup.ArraySchema<any>) => {
  if (type === ParticipantFieldType.option || type === ParticipantFieldType.selection) {
    return testMinEnabledChoices(schema, 1);
  }

  return schema;
};

const withLengthValidation = (type: ParticipantFieldType | null, schema: yup.ArraySchema<any>) => (
  type
    ? typeBasedLengthValidation(type, schema)
    : schema.when('type', typeBasedLengthValidation)
);

const getParticipantFieldSchema = (type: ParticipantFieldType | null) => yup.object().shape({
  ...(type ? {} : { type: yup.string() }),
  title: yup.string().ensure().required(),
  choices: withLengthValidation(type, yup.array(yup.object({
    title: yup.string().ensure().required(),
    enabled: yup.boolean(),
  }))),
  validation_url: yup.string().nullable(),
  validation_success_response: yup.string().nullable(),
});

export default getParticipantFieldSchema;
